import { HotelLocation } from '@/__generated';

export function isTextMatched(tag, match) {
  if (tag !== undefined && match !== '') {
    if (tag.toLocaleLowerCase() === match.toLocaleLowerCase()) {
      return true;
    }
    return false;
  }
  return false;
}

export const getCenterLocation = (locations: Array<HotelLocation | null | undefined>) => {
  let validLocation = locations.filter(x => x?.lat && x?.lon);
  const lats = validLocation.map(m => m?.lat || 0);
  const lons = validLocation.map(m => m?.lon || 0);
  return {
    lat: (Math.min(...lats) + Math.max(...lats)) / 2,
    lon: (Math.min(...lons) + Math.max(...lons)) / 2,
  };
};

export const scrollToElementById = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent> | null | undefined, id: string) => {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  var scrollDiv = document.getElementById(id)?.offsetTop || 0;
  window.scrollTo({ top: scrollDiv - 50, behavior: 'smooth' });
};
